/** @jsx jsx */
import { jsx, css } from '@emotion/react';

const containerStyle = css`
  margin: 40px 80px;
  text-align: center;
`;
const titleStyle = css`
  font-weight: 700;
  font-size: 18px;
`;

export const ListNoResults = () => {
  return (
    <div css={containerStyle} data-pa11y-id="pa11y-runlog-body">
      <p css={titleStyle}>No workflow results (yet)</p>
      <p>
        Either this workflow hasn&apos;t run yet or it hasn&apos;t been
        triggered in the last 30 days. Check here next time it runs to see the
        results. If you have recently triggered this workflow, use the refresh
        button to see your run data.
      </p>
    </div>
  );
};
